import { abortableSleep, isTransientError, makeAbortError } from './async';

// Retry com backoff exponencial abortável.
//
// Características:
// - Sleep cancelável (latência de abort O(0) em vez de O(base*2^i))
// - shouldRetry injetável para evitar retries em 4xx permanentes
// - Jitter aleatório para evitar thundering herd em retries coordenados
export const withRetry = async (fn, { max = 3, base = 800, signal, shouldRetry = isTransientError } = {}) => {
    let lastError;
    for (let i = 0; i < max; i++) {
        if (signal?.aborted) throw makeAbortError();
        try {
            return await fn();
        } catch (e) {
            if (e?.name === 'AbortError') throw e;
            if (!shouldRetry(e, i)) throw e;
            lastError = e;
            if (i === max - 1) break;
            const delay = base * 2 ** i + Math.random() * 200;
            await abortableSleep(delay, signal);
        }
    }
    throw lastError;
};

// ID curto para nomes de arquivo. Entropy: ~36^16 ≈ 7.9e24 — suficiente para
// anti-colisão. NÃO é criptograficamente seguro: para enumeration-resistance
// (path guessing) migrar para expo-crypto.randomUUID() quando disponível.
export const shortId = () => {
    const t = Date.now().toString(36);
    const r1 = Math.random().toString(36).slice(2, 10);
    const r2 = Math.random().toString(36).slice(2, 10);
    return `${t}-${r1}${r2}`;
};
